import React, { useEffect } from 'react';
import Config from 'webapp/config/config';
import HeaderBar from './header_bar';
import Header from 'webapp/components/shared/header';
import Actions from 'webapp/actions/actions';

import LogoConcert from 'webapp/images/logo-concert.svg';
import QAHidden from './qahidden';
import Anchor from 'webapp/components/shared/anchor';
import AuthHelper from 'webapp/helpers/auth_helper';
import LocationHelper from 'webapp/helpers/location_helper';
import Local_logo from './local_logo';
import QAHiddenMini from './qahiddenmini';
import { useSelector } from 'react-redux';

const { cacheBust } = Config;

const FaviconConcert = `/concert/favicon.ico?cacheBust=${cacheBust}`;
const AppleTouchIconConcert = `/concert/apple-touch-icon.png?cacheBust=${cacheBust}`;
const ManifestConcert = `/concert/manifest.webmanifest?cacheBust=${cacheBust}`;

function updateMetadata() {
  let faviconSrc = FaviconConcert;
  let appleTouchIconSrc = AppleTouchIconConcert;
  let manifestSrc = ManifestConcert;
  let title = 'Concert Finance';

  let favicon = document.getElementById('dynamic-favicon');
  let appleTouchIcon = document.getElementById('dynamic-apple-touch-icon');
  let manifest = document.getElementById('dynamic-manifest');

  if (favicon === null || favicon === undefined) {
    favicon = document.createElement('link');
    favicon.id = 'dynamic-favicon';
    favicon.rel = 'shortcut icon';
    document.head.appendChild(favicon);
  }
  if (appleTouchIcon === null || appleTouchIcon === undefined) {
    appleTouchIcon = document.createElement('link');
    appleTouchIcon.id = 'dynamic-apple-touch-icon';
    appleTouchIcon.rel = 'shortcut icon';
    document.head.appendChild(appleTouchIcon);
  }
  if (manifest === null || manifest === undefined) {
    manifest = document.createElement('link');
    manifest.id = 'dynamic-manifest';
    manifest.rel = 'manifest';
    document.head.appendChild(manifest);
  }

  favicon.setAttribute('href', faviconSrc);
  appleTouchIcon.setAttribute('href', appleTouchIconSrc);
  manifest.setAttribute('href', manifestSrc);
  document.title = title;
}

const LogoBar = ({ loggedIn, isInstallerUser }) => {
  const hideHeader = useSelector((redux) => redux.hideHeader);

  useEffect(() => {
    if (
      isInstallerUser &&
      loggedIn &&
      (AuthHelper.isUWImpersonating() || AuthHelper.getSessionToken()) &&
      (typeof window.location !== 'string' || !window.location.includes('/login'))
    ) {
      Actions.fetchAuthenticatedUser();
    }
  }, [isInstallerUser, loggedIn]);

  updateMetadata();
  loggedIn = loggedIn || false;
  const impersonationMode = !!AuthHelper.getImpersonateCookie();

  let uwPlatform = window.location.href.includes('uw.');
  const isImpUW = AuthHelper.isUWImpersonating() && uwPlatform;

  let NavLogo = LogoConcert;
  if (isImpUW) {
    NavLogo = LogoConcert;
  }

  if (LocationHelper.getEnvByDomain() !== 'prod' && LocationHelper.getEnvByDomain() !== 'qa') {
    NavLogo = 'data:image/svg+xml;base64,' + btoa(Local_logo());
  }
  return (
    <Header className={`logo-bar ${impersonationMode && !isImpUW ? 'impersonation-color' : ''}`}>
      {loggedIn && <HeaderBar hamburgerMenu />}
      <div className="logo-content">
        {hideHeader && (
          <div className={'logo-image'}>
            {' '}
            <img src={NavLogo} alt={'Concert Finance'} className="logo-bluewave-icon icon" height={28} />
          </div>
        )}

        {!isImpUW && !hideHeader && (
          <a className="logo-image" href="/">
            <img src={NavLogo} alt={'Concert Finance'} className="logo-bluewave-icon icon" height={28} />
          </a>
        )}

        {isImpUW && !hideHeader && (
          <button
            className="logo-image button-link link-button"
            onClick={() => {
              window.location.reload();
            }}
          >
            <img src={NavLogo} alt={'Concert Finance'} className="logo-bluewave-icon icon" height={28} />
          </button>
        )}
      </div>
      <div className="spacer" />
      {isInstallerUser && loggedIn && (AuthHelper.isUWImpersonating() || AuthHelper.getSessionToken()) && <HeaderBar />}
      {uwPlatform && !loggedIn && localStorage.getItem('switchCognitoIDToken') && (
        <Anchor
          style={{ color: 'white' }}
          className="log-out"
          onClick={() => {
            Actions.logOut();
            window.location.reload();
          }}
          id="logout-link"
        >
          Logout
        </Anchor>
      )}
      <QAHidden />
      <QAHiddenMini />
    </Header>
  );
};

export default LogoBar;
